module.exports = __webpack_public_path__ + "static/img/14000585.0bdc5fc1.png";